import SaveIcon from '@mui/icons-material/Save';
import {
    useAppSidePanelContextProvider
} from "../../../shared/contexts/app-side-panel-context-provider/components/AppSidePanelContextProvider";
import { ToolsPanelButton } from "./ToolsPanelButton";
import { customImpliedVolatilityInfoBuilder } from "../utils/CustomImpliedVolatilityInfoBuilder";

export function SaveCustomImpliedVolatilityButton(){
    const {
        selectedPortfolio,
        saveCustomImpliedVolatility,
    } = useAppSidePanelContextProvider();
    
    const handleSavePortfolio = async (): Promise<void> => {
        if (!selectedPortfolio) {
            return;
        }

        const { positionsForUpdate, ordersForUpdate } =
            customImpliedVolatilityInfoBuilder.build(selectedPortfolio);
        
        await saveCustomImpliedVolatility(positionsForUpdate, ordersForUpdate);
    };
    
    return (
        <ToolsPanelButton
            tooltipText="Save custom implied volatility values for positions and related orders"
            disabled={false}
            onChanged={handleSavePortfolio}
        >
            <SaveIcon sx={{
                height: '18px',
                width: '18px',
            }} />
        </ToolsPanelButton>
    );
}
